import { lang, commonLang, _system, isSystem, getCurrentLang } from '@umu/ukit-lang';
import React, { Fragment, useEffect, useState } from 'react';
import API from '@umu/umu-api';
import { $window, getQueryString } from '@umu/umu-dom';
import { checkIsURLEncoded } from '@umu/umu-util';
import { isWxChat } from '@umu/umu-ua';
import { fetch } from '@umu/umu-fetch';

import { pinUrl, buildTenantIdQuery, getFactFromUrl, isFromCourseMiniApp, getMiniAppSdk } from '../../../@utils';
import './menuItem.scss';
import { useDebounceFn } from 'ahooks';

interface IMenuItemProps {
    text: string;
    url: string;
    className?: string;
}
interface IOfficialUserInfo {
    official_announcement_status: OFFICIAL_ANNOUNCEMENT_STATUS;
    bind_wx: number;
    bind_phone: string;
}
enum OFFICIAL_ANNOUNCEMENT_STATUS {
    HIDE,
    SHOW,
    SHOW_MSG,
}
function LinkMenuItem(props: IMenuItemProps) {
    return (
        <div className={`link-menu-item ${props.className || ''}`}>
            <a href={props.url}>{props.text}</a>
        </div>
    );
}

export function Split() {
    return <span className="split-menu-item" />;
}

export function Login() {
    let fromUrl;
    // 无权限页强制登录后跳转from_url
    if (/^\/access-denied\//.test(window.location.pathname)) {
        fromUrl = getQueryString('from_url');
    }
    if (!fromUrl) {
        fromUrl = $window.location.href;
    }

    const isFromURLEncoded = checkIsURLEncoded(fromUrl);
    return (
        <LinkMenuItem
            text={lang('登录')}
            url={`/globaluser/loginpage?from_url=${isFromURLEncoded ? fromUrl : encodeURIComponent(fromUrl)}`}
        />
    );
}

export function Register() {
    return (
        <LinkMenuItem
            text={lang('注册')}
            url={`/globaluser/registerpage?from_url=${encodeURIComponent($window.location.href)}`}
        />
    );
}

export function Event() {
    return <LinkMenuItem text={lang('课程互动')} url={`/index/event`} />;
}

export function Course() {
    return <LinkMenuItem text={lang('微课制作')} url={`/index/course`} />;
}

export function Platform() {
    return <LinkMenuItem text={lang('企业学习平台')} url={`/product/enterprise`} />;
}
export function AiAudioSlides() {
    let component;
    component = <LinkMenuItem text={lang('AI 微课')} url={`/product/ai-audio-slides`} />;
    return component;
}
export function LearningDesign() {
    return <LinkMenuItem text={lang('教学工具')} url={`/product/learning-design`} />;
}
export function ProductExercise() {
    return <LinkMenuItem text={lang('AI 作业')} url={`/product/exercise`} />;
}
export function ProductLive() {
    return <LinkMenuItem text={lang('互动直播')} url={`/product/live`} />;
}
export function ProductEvent() {
    let component;
    component = <LinkMenuItem text={lang('现场互动')} url={`/product/event`} />;
    return component;
}
export function PlanPricing() {
    let component;
    component = <LinkMenuItem text={lang('定价')} url={`/plan/pricing`} />;
    return component;
}
export function Education() {
    let component;
    component = <LinkMenuItem text={lang('UMU教育计划')} url={`/home/edu`} />;
    return component;
}
export function LearnTask() {
    return <LinkMenuItem text={lang('我的任务_1')} url={'/profile/assignment'} />;
}

export function ParticipatedCourse() {
    return <LinkMenuItem text={lang('学习历史')} url={'/profile/#/participated'} />;
}

export function Website() {
    return <LinkMenuItem text={lang('UMU官网')} url={'/home'} />;
}

export function AITools() {
    return <LinkMenuItem text={lang('AI 工具')} url={'/ai-tools'} />;
}

export function OFficialAnnouncement() {
    const [announcementStatus, setAnnouncementStatus] = useState<OFFICIAL_ANNOUNCEMENT_STATUS>(
        OFFICIAL_ANNOUNCEMENT_STATUS.HIDE,
    );
    const onInit = () => {
        fetch.get('/api/profile/userinfo').then((res: { data: { teacherInfo: IOfficialUserInfo } }) => {
            const teacherInfo = res?.data?.teacherInfo || {};
            if (teacherInfo && teacherInfo.official_announcement_status) {
                setAnnouncementStatus(Number(teacherInfo.official_announcement_status));
            }
        });
    };
    useEffect(() => {
        onInit();
    }, []);
    const isShow = announcementStatus !== OFFICIAL_ANNOUNCEMENT_STATUS.HIDE;
    const cls = announcementStatus === OFFICIAL_ANNOUNCEMENT_STATUS.SHOW_MSG ? 'announcements-btn-circle-msg' : '';
    return isShow ? <LinkMenuItem text={lang('官方公告')} url={'/announcements/index'} className={cls} /> : <></>;
}
export function Class() {
    return <LinkMenuItem text={lang('班级')} url={'/class/list'} />;
}

export function Faq() {
    if (!isSystem('JP')) {
        return null;
    }
    const lang = getCurrentLang();
    const text = lang === 'jp' ? 'よくある質問' : 'FAQ';
    return <LinkMenuItem text={text} url={'https://tayori.com/faq/e789bde6e91c09073e63704a4be1872ac2b27902/'} />;
}

export function Academy() {
    const currentLang = getCurrentLang();
    const text = currentLang === 'jp' || currentLang === 'en' ? 'UMU Academy' : lang('UMU 小课堂');
    if (isSystem('EN')) {
        return <LinkMenuItem text={text} url={'https://e.umu.com/umuacademy'} />;
    }
    if (!isSystem('JP')) {
        return null;
    }
    return <LinkMenuItem text={text} url={'https://m.umu.co/main?eid=umu_academy#/index&parentCategoryId=-1'} />;
}

export function InputPin() {
    return <LinkMenuItem text={lang('输入访问码')} url={pinUrl} />;
}

export function Index() {
    return <LinkMenuItem text={lang('首页')} url={'/'} />;
}

export function Collections() {
    return <LinkMenuItem text={lang('我的收藏_1')} url={`/favorite/list/favorite`} />;
}

export function QuestionCollections() {
    return <LinkMenuItem text={commonLang('考题本')} url={`/favorite/list/question`} />;
}
/**
 * @desc 官网-uShow介绍页面
 */
export function UShowIntroducePanel() {
    return <LinkMenuItem text={lang('uShow')} url={'/product/u-show'} />;
}
/**
 * @desc 官网-测评介绍页面
 */
export function AssessmentIntroducePanel() {
    return <LinkMenuItem text={lang('测评')} url={'/product/assessment'} />;
}
/**
 * @desc 官网-学习圈介绍页面
 */
export function LearningCircleIntroducePanel() {
    return <LinkMenuItem text={lang('学习圈')} url={'/product/learning-circle'} />;
}
/**
 * @desc 官网-资源和动态介绍页面
 */
export function ResourcesAndDynamicsIntroducePanel() {
    let url = 'https://blog.umu.com';
    if (_system('cn')) {
        url = 'https://blog.umu.cn';
    }
    if (_system('jp')) {
        url = 'https://umujapan.co.jp/category/column/';
    }
    if (_system('em')) {
        url = 'https://blog.umu.io';
    }

    return isSystem('CN') || isSystem('JP') ? (
        <Fragment>
            <LinkMenuItem text={lang('资源和动态')} url={url} />
            <Split />
        </Fragment>
    ) : null;
}

export function Logout() {
    const handleClickLogout = (evt: React.MouseEvent<HTMLElement>) => {
        evt.preventDefault();
        evt.stopPropagation();

        fetch.get(API.Path.USER_LOGOUT.url).then(() => {
            // 无权限页退出登录时，需要跳转到from_url中的链接，方便后端刷新当前显示状态
            if (/^\/access-denied\//.test(window.location.pathname)) {
                const fromUrl = getQueryString('from_url');
                if (fromUrl) {
                    window.location.href = decodeURIComponent(fromUrl);
                }
            }

            window.location.reload();
        });
    };

    if (isWxChat) {
        const url = $window.location.href;
        const query = buildTenantIdQuery(url);
        const fromUrl = getFactFromUrl();
        const switchAccountUrl = `/globaluser/loginpage?${query}from_url=${encodeURIComponent(fromUrl)}#/skip_profile`;
        if (isFromCourseMiniApp()) {
            return (
                <div
                    className="link-menu-item"
                    onClick={() => {
                        getMiniAppSdk().redirectTo('/pages/login/index?needClear=1');
                    }}
                >
                    <a>{lang('切换账号')}</a>
                </div>
            );
        }
        return (
            <div className="link-menu-item">
                <a href={switchAccountUrl}>{lang('切换账号')}</a>
            </div>
        );
    }
    return (
        <div onClick={handleClickLogout} className="link-menu-item">
            <a href="#">{lang('退出登录')}</a>
        </div>
    );
}

export function ContactUs() {
    let component;
    component = (
        <div className="link-menu-item contact-us-item">
            <a href="tel:400-007-2121" className="tel">
                <span className="telphone-number">400-007-2121</span>
            </a>
        </div>
    );
    return component;
}

export const BindWx = (props: any) => {
    const [hasBindWx, setHasBindWx] = useState(false);
    const onInit = () => {
        fetch.get('/api/profile/userinfo').then((res: { data: { teacherInfo: IOfficialUserInfo } }) => {
            const teacherInfo = res?.data?.teacherInfo || {};
            setHasBindWx(!!teacherInfo.bind_wx);
        });
    };
    useEffect(() => {
        onInit();
    }, []);

    const onClick = useDebounceFn(
        () => {
            getMiniAppSdk().navigateTo('/subModuleA/pages/accountBind/index?type=wx');
            props?.controller?.close();
        },
        { wait: 1000 },
    );

    return (
        <div className="bind-wx-menu-item">
            <div onClick={onClick.run}>
                <span className="item-label">{lang('绑定微信')}</span>
                <span className={`item-value ${!hasBindWx ? 'no-bind' : ''}`}>
                    <span>{hasBindWx ? lang('已绑定') : lang('未绑定')}</span>
                    <i className="icon icon-arrow arrow1 gray right size-xs" />
                </span>
            </div>
        </div>
    );
};

export const BindPhone = (props: any) => {
    const [phone, setPhone] = useState('');

    const onInit = () => {
        fetch.get('/api/profile/userinfo').then((res: { data: { teacherInfo: IOfficialUserInfo } }) => {
            const teacherInfo = res?.data?.teacherInfo || {};
            setPhone(teacherInfo.bind_phone);
        });
    };

    useEffect(() => {
        onInit();
    }, []);

    const onClick = useDebounceFn(
        () => {
            getMiniAppSdk().navigateTo('/subModuleA/pages/accountBind/index?type=phone');
            props?.controller?.close();
        },
        { wait: 1000 },
    );

    return (
        <div className="bind-phone-menu-item">
            <div onClick={onClick.run}>
                <span className="item-label">{lang('绑定手机号')}</span>
                <span className={`item-value ${!phone ? 'no-bind' : ''}`}>
                    <span>{!!phone ? phone : lang('未绑定')}</span>
                    <i className="icon icon-arrow arrow1 gray right size-xs" />
                </span>
            </div>
        </div>
    );
};
